document.addEventListener('DOMContentLoaded', function () {
  const modalTriggers = document.querySelectorAll('a[data-micromodal-trigger]');
  let scrollPosition = 0;

  modalTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault(); // デフォルトのリンク動作を無効化
      scrollPosition = window.pageYOffset; // 現在のスクロール位置を保存
      // document.body.classList.add('fixed');
      // document.body.style.top = `-${scrollPosition}px`;
    });
  });

  MicroModal.init({
    disableScroll: true,
    onClose: function () {
      // document.body.classList.remove('fixed');
      // document.body.style.top = '';
      // window.scrollTo(0, scrollPosition); // 保存した位置にスクロール
    }
  });
});
